const a = (t, e = "$") => {
  const r = typeof t == "number" ? t : Number(t);
  return !r && r !== 0 ? t.toString() : `${e}${r.toFixed(2)}`;
}, f = (t) => {
  const e = s(t);
  let r = e.getDate();
  if (!r)
    return "";
  r = n(r);
  const o = n(e.getMonth() + 1), c = e.getFullYear();
  return `${r}/${o}/${c}`;
}, p = (t) => t.replace(/[-_]/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2").split(" ").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" "), i = (t) => {
  const e = typeof t == "number" ? t : Number(t);
  return e ? `${e}%` : "0%";
}, s = (t) => {
  if (typeof t == "object")
    return t;
  const e = typeof t == "string" && t.indexOf("-") === -1 ? parseInt(t, 10) : t;
  return new Date(e);
}, n = (t) => t < 10 ? `0${t}` : `${t}`;
export {
  a as formatCurrency,
  f as formatDate,
  p as formatObjectKey,
  i as formatPercentage,
  s as getDateObj,
  n as pad
};
